import { render, staticRenderFns } from "./IconCheckboxAround.vue?vue&type=template&id=652d4a40&scoped=true&"
import script from "./IconCheckboxAround.vue?vue&type=script&lang=js&"
export * from "./IconCheckboxAround.vue?vue&type=script&lang=js&"
import style0 from "./IconCheckboxAround.vue?vue&type=style&index=0&id=652d4a40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d4a40",
  null
  
)

export default component.exports